import React from "react";

const Avatar4 = ({ color = "#222" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 75 75">
    {/* Outer Circle */}
    <g>
      <path
        fill={color}
        d="M37.5 70.72A33.26 33.26 0 0 1 4.27 37.5 33.26 33.26 0 0 1 37.5 4.27 33.26 33.26 0 0 1 70.72 37.5 33.26 33.26 0 0 1 37.5 70.72Zm0-64.66A31.47 31.47 0 0 0 6.06 37.5 31.47 31.47 0 0 0 37.5 68.94 31.47 31.47 0 0 0 68.94 37.5 31.47 31.47 0 0 0 37.5 6.06Z"
      />
    </g>

    {/* Main Shape */}
    <g clipPath="url(#b)">
      <path
        fill={color}
        fillRule="evenodd"
        d="M37.5 59.03a.48.48 0 0 1-.33-.12c-4.96-4.33-18.99-1.85-19.13-1.82a.5.5 0 0 1-.6-.5v-24.3c0-.28.23-.5.51-.5h1.8v19.96c0 .77.66 1.4 1.43 1.34 4.48-.27 11.59.34 15.37 2.88.45.3 1.05.3 1.5 0 3.76-2.54 10.9-3.16 15.37-2.88.77.05 1.43-.57 1.43-1.34V31.79h2.2c.27 0 .5.22.5.5v24.3a.5.5 0 0 1-.6.5c-.14-.03-14.16-2.5-19.12 1.82a.5.5 0 0 1-.33.12Z"
      />
    </g>

    {/* Extra Lines and Details */}
    <path
      fill={color}
      fillRule="evenodd"
      d="M37.3 55.36c-.1 0-.2-.03-.28-.09-5.46-3.67-15.79-3.02-15.9-3.02a.5.5 0 0 1-.53-.5V27.57c0-.27.21-.5.49-.5 4.3-.11 7.99.52 10.31 1.06a13.29 13.29 0 0 0-1.71 8.14 1.35 1.35 0 0 0 2.41.69c.35-.46 1.93-2.37 2.33-2.47h5.56c.54.12 2.11 1.99 2.53 2.55.73.98 2.3.53 2.41-.7.24-2.8-.22-5.78-1.76-8.22a38.9 38.9 0 0 1 10.36-1.05c.27 0 .5.23.5.5v24.18a.5.5 0 0 1-.55.5c-.1 0-10.43-.64-15.9 3.02a.48.48 0 0 1-.27.09Zm0-11.68a.52.52 0 0 1-.4-.18c-.53-.68-4.13-5.58-1.2-7.68.54-.38 1.13.44.59.82-1.82 1.3.23 4.57 1 5.69.78-1.12 2.84-4.39 1.01-5.69-.53-.38.05-1.2.6-.82 2.92 2.1-.67 7-1.2 7.68a.52.52 0 0 1-.4.18Zm11.49-9.04h-2.6c-.65 0-.65-1 0-1h2.6c.66 0 .66 1 0 1Zm0 3.97h-6.77c-.67 0-.67-1 0-1h6.77c.66 0 .66 1 0 1Zm0 3.34h-7.7c-.66 0-.66-1 0-1h7.7c.66 0 .66 1 0 1Zm0 7.42h-9.06c-.67 0-.67-1 0-1h9.06c.66 0 .66 1 0 1Zm-16.63-10.7H25.8c-.66 0-.66-1 0-1h6.35c.66 0 .66 1 0 1Zm1.34 3.28h-7.69c-.66 0-.66-1 0-1h7.69c.66 0 .66 1 0 1Zm15.29 3.71h-9.06c-.67 0-.67-1 0-1h9.06c.66 0 .66 1 0 1Zm-13.92 0h-9.06c-.66 0-.66-1 0-1h9.06c.67 0 .67 1 0 1Zm0 3.72h-9.06c-.66 0-.66-1.01 0-1.01h9.06c.67 0 .67 1 0 1ZM28.4 34.63h-2.59c-.66 0-.66-1 0-1h2.6c.65 0 .66 1 0 1Z"
    />
    <path
      fill={color}
      fillRule="evenodd"
      d="M43.58 36.73a.5.5 0 0 1-.4-.2c-.8-1.06-2.2-2.63-2.83-2.8-.51-.2 1.14-4.12.72-5.3-.45-.48.27-1.18.73-.7.12.11 2.77 2.96 2.29 8.54a.5.5 0 0 1-.5.46Zm-12.56-.07a.5.5 0 0 1-.5-.46c-.47-5.41 1.98-8.24 2.26-8.54.45-.49 1.2.2.74.68-1.3 1.42.92 4.31.71 5.32-.64.2-2.03 1.75-2.81 2.8a.5.5 0 0 1-.4.2Zm0 0"
    />
    <path
      fill={color}
      fillRule="evenodd"
      d="M39.06 36.73h-3.52a.5.5 0 0 1-.43-.23 17.63 17.63 0 0 1-1.29-15.36c.83.52 2.99.69 3.48.69 1.14 0 2.44-.23 3.47-.69A17.66 17.66 0 0 1 39.5 36.5a.5.5 0 0 1-.43.23ZM34.22 20.2a14.93 14.93 0 0 1 2.71-4.02.5.5 0 0 1 .73 0 14.83 14.83 0 0 1 2.71 4.02l-.12.04a7.79 7.79 0 0 1-6.03-.04Zm3.08 7.22c-2.74 0-2.74-4.16 0-4.16s2.74 4.16 0 4.16Zm0-3.15c-1.42 0-1.42 2.14 0 2.14 1.41 0 1.41-2.14 0-2.14Zm0 0"
    />
  </svg>
);

export default Avatar4;
